/* LabJnibAdapterAddOn.js */

"use strict";
const _ = require("lodash");
const mix = require("../util/mix");
const BaseJnibAdapter = require("../lab/LabBaseJnibAdapter");
const NibApiMixin = require("../CommonNibApiMixin");

const UserSessionMixin = require("../lab/LabUserSessionMixin.js");

const WizardUIMixin = require("../BaseWizardUIMixin");
const CommonUIMixin = require("../BaseCommonUIMixin");

const AbstractServiceFactory = require("@gluenetworks/platform-sdk-remote").serviceFactories
    .AbstractServiceFactory;

class LabJnibAdapterAddOn extends mix(BaseJnibAdapter).with(
    NibApiMixin,
    UserSessionMixin,
    WizardUIMixin,
    CommonUIMixin
) {
    constructor(labUserSesion) {
        super(labUserSesion);
        //This is set during the initialization phase and is expected to be in place by all mixins.
        this._nibApiService = null;
        this._serviceFactory = AbstractServiceFactory.getInstance("http", {
            connectionOptions: {
                protocol: window.location.protocol,
                hostname: window.location.hostname,
                port: window.location.port,
            },
        });
    }
    get nibApiService() {
        return this.getNibApiService();
    }
    getNibApiService() {
        return this._nibApiService;
    }
    /*******************************************/
    /* START STEVE ADD-ON METHODS              */
    /*******************************************/
    initialize(/*steve, addOnOptions*/) {
        //jshint ignore:line
        return (
            Promise.resolve()
                .then(() => {
                    return new Promise((resolve) => {
                        //MonkeyPatch the NIB adapter and attempt to keep "this" straight
                        for (let key in this._nibAdapter) {
                            //If this key is being overwritten
                            if (key in this) {
                                if (_.isFunction(this._nibAdapter[key])) {
                                    this._nibAdapter[key] = this[key].bind(this);
                                } else {
                                    this._nibAdapter[key] = this[key];
                                }
                            }
                        }
                        //Note: At this point the webJnibEngine is waiting for the next turn of the event loop
                        //to initialize itself, so we will do the same here so we make sure things are properly setup
                        setTimeout(() => {
                            resolve();
                        }, 0);
                    });
                })
                //load the nibApiService
                .then(() => {
                    return Promise.resolve()
                        .then(() => {
                            return this._serviceFactory.getServiceInstance("NibApi");
                        })
                        .then((nibApiService) => {
                            this._nibApiService = nibApiService;
                        });
                })
        );
    }
    startUp(/*steve, addOnOptions*/) {
        //jshint ignore:line
        //TODO add creds at somepoint maybe...
        return this._labUserSession.login();
    }
    /*******************************************/
    /* END STEVE ADD-ON METHODS                */
    /*******************************************/
}
module.exports = LabJnibAdapterAddOn;
module.exports.$inject = ["$teve.userSession", "$teve.services.http.NibApi"];
